import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ENVIRONMENT } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { AlertComponent, CustomMissingTranslationHandler } from '@balloon-race-fullstack-monorepo/dbr-common';
import { DbrApiService } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

/**
 * Create a custom translation loader
 * @param httpClient
 * @returns {TranslateHttpLoader}
 */
export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, ENVIRONMENT.TRANSLATION_PATH, '.json');
}

/**
 * Factory for CustomMissingTranslationHandler
 * @returns {CustomMissingTranslationHandler}
 */
export function createCustomMissingTranslationHandler() {
  return new CustomMissingTranslationHandler();
}

@Component({
    imports: [RouterModule, AlertComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'dbr-launcher-app';
  private translateService = inject(TranslateService);
  private apiService = inject(DbrApiService);

  constructor() {
    this.translateService.setDefaultLang('de');
    this.translateService.use('de');

    this.apiService.rootUrl = ENVIRONMENT.API.BASE_URL;
  }
}
